import React from 'react';

import {
    BaseToolbarDimension,BaseToolbarMarginOrPadding, BaseToolbarInputGroup, BaseInput, BaseToolbarSelect, BaseToolbarJson,
} from 'wsc-react-custom-form';
export const Settings = () => {
    return (
        <React.Fragment>
            {/* 把一组input统一包起来， 可以用caption属性来置顶一个统一的标题 */}
            <BaseToolbarInputGroup>
                {/*  widthRation可选：不填的话，label宽度占30%；填写的值在1-99之间*/}
                <BaseInput propKey='name' label='Name' tooltipTitle='存储表单值的key' widthRation={50}/>
                <BaseInput propKey='text' label='按钮文字' tooltipTitle='按钮文字' widthRation={50}/>
                <BaseToolbarSelect
                    propKey='disabled'
                    label='禁用'
                    tooltipTitle='是否按钮'
                    options={[
                        {value: 'true', label: '禁用'},
                        {value: 'false', label: '不禁用'}
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='size'
                    label='尺寸'
                    tooltipTitle='按钮尺寸'
                    options={[
                        {value: 'default', label: '默认'},
                        {value: 'mini', label: '小尺寸'}
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='type'
                    label='类型'
                    tooltipTitle='按钮类型'
                    options={[
                        {value: 'primary', label: 'primary'},
                        {value: 'default', label: 'default'},
                        {value: 'warn', label: 'warn'},
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='plain'
                    label='镂空'
                    tooltipTitle='镂空'
                    options={[
                        {value: 'true', label: '是'},
                        {value: 'false', label: '否'}
                    ]}
                    widthRation={50}
                />

                <BaseInput propKey='url' label='处理地址' tooltipTitle='处理流程的地址' widthRation={50}/>
                <BaseInput propKey='api' label='HTTP请求' tooltipTitle='业务请求提交地址' widthRation={50}/>
                <BaseToolbarJson propKey="headers"  label='headers'  tooltipTitle='自定义请求头' widthRation={50}/>
                <BaseInput propKey='successFlag' label='调用api后成功属性' tooltipTitle='调用api后成功属性' widthRation={50} />
                <BaseInput propKey='businessKey' label='调用api后业务主键' tooltipTitle='调用api后业务主键' widthRation={50} />
                <BaseToolbarMarginOrPadding name='margin'/>
            </BaseToolbarInputGroup>

        </React.Fragment>
    );
};
